import localforage from 'localforage'

const viewEventsStore = localforage.createInstance({
  name: 'hom-stat-events',
  storeName: 'page-view-events',
  description: 'user events',
})

export default viewEventsStore
